// extracted by css-extract-rspack-plugin
export default {"suggestionButton":"SuggestionCard-module__suggestionButton__vbaWy","icon":"SuggestionCard-module__icon__p_Go2"};